<template>
  <h1>
    <p class="cn" v-if="title">{{title}}</p>
    <p class="en" v-if="titleEn">
      <a :href="link" target="_blank" :class="{'hasLink': !!link}">{{titleEn}}</a>
    </p>
  </h1>
</template>

<script>
export default {
  props: [
    'title', 'title-en', 'link'
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"
h1
  text-align: center
  margin-bottom: 40px
  +mobile
    margin-bottom: 20px
  .cn
    font-size: 34px
    color: $black-ter
    margin-bottom: 0 !important
    // background: url(../../assets/a-title.png) no-repeat center
    // background-size: 84px auto
    +mobile
      font-weight: 500
      font-size: 22px
      color: $primary
  .en
    text-transform: uppercase
    font-size: 14px
    color: #888
    a
      color: #888
      &.hasLink
        color: $primary
  &.light .cn
    color: $white
    // background-image: url(../../assets/b-title.png)
  &.small .cn
    font-size: 30px
    // background-image: url(../../assets/small.png)
    // background-size: 60px auto

</style>
